import type * as React from 'react';
const SvgIcoShieldRoundedAutoAwesomeStack = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m11.8 2.26-6 2.25c-.78.3-1.3 1.04-1.3 1.88v4.7c0 4.83 3.13 9.37 7.43 10.75.37.12.77.12 1.14 0 4.3-1.38 7.43-5.91 7.43-10.75v-4.7a2 2 0 0 0-1.3-1.87l-6-2.25c-.45-.18-.95-.18-1.4-.01"
      fill="currentColor"
    />
    <path
      d="m15.419 9.667.362-.802.802-.363a.23.23 0 0 0 0-.417l-.802-.362-.362-.806a.23.23 0 0 0-.417 0l-.362.802-.807.362a.23.23 0 0 0 0 .417l.802.362.362.807c.083.178.34.178.422 0m-3.649.687-.728-1.604a.458.458 0 0 0-.835 0l-.728 1.604-1.604.729a.458.458 0 0 0 0 .834l1.604.729.729 1.604a.458.458 0 0 0 .834 0l.728-1.604 1.605-.729a.458.458 0 0 0 0-.834zm3.227 2.98-.362.801-.802.363a.23.23 0 0 0 0 .417l.802.362.362.806a.23.23 0 0 0 .417 0l.362-.802.807-.362a.23.23 0 0 0 0-.417l-.802-.362-.362-.807a.233.233 0 0 0-.422 0"
      fill="currentColor"
    />
  </svg>
);
export default SvgIcoShieldRoundedAutoAwesomeStack;
